import { IOnInit } from "angular";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../../application/UserProfile";
import {
  ContractService,
  ContractTypeService,
  vsServiceName as ContractServiceName,
} from "../../ContractService";

export class ContractDetailComponentController implements IOnInit {
  //bindings
  contract: any;
  contractType!: ContractTypeService;
  //end bindings

  static $inject = [UserProfileName, ContractServiceName];
  constructor(readonly userProfile: UserProfile) {}

  $onInit(): void {}
}
